import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/utils';
import { transCls } from '../const/ui';
import { BsTooltip } from './tooltip';

export interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  tooltip?: string;
  hoverTextCls?: string;
}

export const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ className, children, hoverTextCls, tooltip, icon, type, ...rest }, ref) => {
    const btn = (
      <button
        ref={ref}
        type={type ?? 'button'}
        className={cn(
          'group inline-flex items-center gap-[6px] px-[16px] rounded-[4px] h-[34px]',
          'border border-solid border-[#E0E0E0] bg-transparent',
          'text-[14px] font-[400] leading-[normal] text-[#030303]',
          'hover:bg-[#EFF0F6] hover:border-transparent',
          'cursor-pointer',
          {
            'hover:text-[#0265FF]': !hoverTextCls,
            [`hover:${hoverTextCls}`]: hoverTextCls,
          },
          transCls,
          className
        )}
        {...rest}
      >
        {icon ? <span className="shrink-0">{icon}</span> : null}
        {children ? (
          <span className="whitespace-nowrap">{children}</span>
        ) : null}
      </button>
    );

    if (tooltip) {
      return <BsTooltip content={tooltip}>{btn}</BsTooltip>;
    }

    return btn;
  }
);

BaseButton.displayName = 'BaseButton';
